<template>
  <Modal :visible="visible" @hide="onCancel" :back-drop="false">
    <div class="bonus" align="center">
      <div class="label">{{ $t("listen_teacher.congratulations") }}</div>
      <img src="/assets/new/bonus_popup_bg.png">
      <div class="gain">{{ $t("listen_teacher.bonus_gain") }}</div>
      <div class="point h-layout align-items-center justify-center">
        <label>
          {{ utils.thousandSeparator(data.point) }}
        </label>
        <img src="/assets/new/ic_point.png" height="16" width="16" class="ml-3 mt-1"/>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";
import * as utils from '../../utils/utils'

export default {
  name: "BonusPopup",
  props: {
    visible:{
      type:Boolean,
      default:false,
    },
    data:{
      type:Object,
      default:{
        point:0
      }
    }
  },
  components: {Modal},
  data() {
    return {
      utils:utils,
    }
  },
  mounted() {
  },
  methods: {
    onCancel(){
      this.$emit('update:visible', false);
    },
  }
}
</script>

<style scoped lang="scss">
.bonus{
  font-size: 19px;
  background: white;
  border-radius: 20px;
  position: relative;
  padding-bottom: 20px;
  .label{
    position: absolute;
    color: white;
    top:1.5em;
    left: 50%;
    transform: translateX(-50%);
  }
  .gain{
    font-weight: 600;
  }
  .point{
    font-size: 40px;
    color: $primary-color;
  }
}
</style>